export default "__VITE_ASSET__DXHQ497G__"